import React from 'react'
import ProjectModal from '../../../../components/common/form/modal/ProjectModal'


const ProjectModalContainer = ({ title, open, handleClose, selectedProject }) => {
    return (
        <ProjectModal
            title={title}
            open={open}
            handleClose={handleClose}
            selectedProject={selectedProject}
        />
    )
}

export default ProjectModalContainer